// extracted by mini-css-extract-plugin
export default {"title":"service_title__omgmM","slice_cont":"service_slice_cont__RftLc","card":"service_card__WZRgO","card_img":"service_card_img__JdGTK","card_title":"service_card_title__0z6ea"};